import Select from 'react-select';
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 0, label: "Em digitação" },
    { value: 1, label: "Aguardando análise" },
    { value: 2, label: "Aguardando documentação" },
    { value: 3, label: "Aguardando projeto" },
    { value: 4, label: "Aprovado" },
    { value: 5, label: "Revisão" },
    { value: 6, label: "Arquivado" }
];

const SituacaoAnaliseProjeto = ({ field, placeholder, name, id, disabled=false }) => {
    return (
        <Select 
            options={options} 
            {...field}
            styles={SearchFieldStyles}
            placeholder={placeholder}
            name={name}
            isDisabled={disabled}
            id={id}
        />
    )
}

export { SituacaoAnaliseProjeto, options as OpcoesSituacaoAnaliseProjeto }